import { useMemo } from 'react'
import { getAllCampaigns, Campaign } from '@/services/api/campaign'
import { whiteLabelUtil } from '@/services/api/siteAssets'
import useApi from '@/services/hooks/useApiV2'
import useSiteAssets from '../useSiteAssets/useSiteAssets'

const useCampaigns = (allCampaigns?: Campaign[]) => {
  const { domain } = useSiteAssets()

  const { data, isLoading, isError } = useApi<Campaign[]>({
    key: `campaigns`,
    request: () => getAllCampaigns(),
    config: {
      fallbackData: allCampaigns,
    },
  })

  const campaigns = useMemo(
    () => data?.filter((c) => whiteLabelUtil.isAllowed(c, domain)),
    [data, domain]
  )

  const funding: Campaign[] = []
  const testing: Campaign[] = []
  const closed: Campaign[] = []

  campaigns?.forEach((campaign) => {
    // hide all draft campaigns from visibility:
    if (campaign.draftMode) return

    if (campaign.status === 'closed' || campaign.status === 'archived') {
      closed.push(campaign)
    } else if (campaign.status === 'currently_funding') {
      funding.push(campaign)
    } else {
      testing.push(campaign)
    }
  })

  return {
    campaigns,
    isLoading,
    isError,
    funding,
    testing,
    closed,
  }
}

export default useCampaigns
